import useSelectedFavourites from '../../../zustand/SelectedFavourites';

const useHandleClickFavourites = () => {
  const {
    selectedCompetitions,
    selectedTeams,
    setSelectedCompetitions,
    setSelectedTeams,
  } = useSelectedFavourites();

  const handleRemoveTeam = (team: string) => {
    setSelectedTeams(selectedTeams.filter((t) => t !== team));
  };

  const handleRemoveCompetition = (competition: string) => {
    setSelectedCompetitions(
      selectedCompetitions.filter((c) => c !== competition)
    );
  };

  const handleAddCompetition = (competition: string) => {
    if (!selectedCompetitions.includes(competition)) {
      setSelectedCompetitions([...selectedCompetitions, competition]);
    }
  };

  const resetTeams = () => {
    setSelectedCompetitions([]);
    setSelectedTeams([]);
  };
  return {
    handleRemoveTeam,
    handleRemoveCompetition,
    resetTeams,
    handleAddCompetition,
  };
};

export default useHandleClickFavourites;
